import { Campaign, Fee, TffBookingSource } from '@tff/types/TFF';

export interface FeeFilter {
  dateOfSimulation?: Date;
  bookingSource: TffBookingSource;
  action: string;
  bookingDate: Date;
  channel: string;
  currency: string;
  travelDate: Date;
}

export const filterActiveFee = (campaigns: Campaign[], feeFilter: FeeFilter): Fee | undefined => {
  const filteredCampaigns = campaigns.map(item => Object.assign({}, item, { selected: false }));

  const activeCampaigns: Campaign[] = filteredCampaigns.filter(campaign => {
    const dateOfValidation: Date = feeFilter.dateOfSimulation ? new Date(feeFilter.dateOfSimulation) : new Date();

    return (
      campaign.status === 'aktiv' && // status
      (!campaign.startDate || new Date(campaign.startDate) < dateOfValidation) && // > startDate
      (!campaign.endDate || new Date(campaign.endDate) >= dateOfValidation) && // < endDate
      (!campaign.bookingSources || campaign.bookingSources?.includes(feeFilter.bookingSource)) && // validate bookingSource
      (!campaign.travelStartDate || new Date(campaign.travelStartDate) < new Date(feeFilter.travelDate)) && // > travelStartDate
      (!campaign.travelEndDate || new Date(campaign.travelEndDate) >= new Date(feeFilter.travelDate))
    );
  });

  let activeFee: Fee | undefined;
  activeCampaigns?.forEach(campaign => {
    campaign.fees?.forEach((fee: Fee) => {
      if (
        !activeFee &&
        fee.actions?.includes(feeFilter.action as string) &&
        fee.channel?.includes(feeFilter.channel as string) &&
        fee.currency === feeFilter.currency
      ) {
        activeFee = fee;
      }
    });
  });

  return activeFee;
};
